import { ScenarioOptimizationsActionTypes } from './constants';

type ScenarioOptimizationsAction = { type: string, payload: {} | string };

export const scenarioOptimizationsApiResponseSuccess = (actionType: string, data: any): ScenarioOptimizationsAction => ({
    type: ScenarioOptimizationsActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});

export const scenarioOptimizationsApiResponseError = (actionType: string, error: string): ScenarioOptimizationsAction => ({
    type: ScenarioOptimizationsActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const scenarioOptimizationsGetNoShipments = (query: string): ScenarioOptimizationsAction => ({
    type: ScenarioOptimizationsActionTypes.GET_NO_SHIPMENTS_REQUEST,
    payload: { query },
});

export const scenarioOptimizationsGetTopZone = (query: string): ScenarioOptimizationsAction => ({
    type: ScenarioOptimizationsActionTypes.GET_TOP_ZONE_REQUEST,
    payload: { query },
});

export const scenarioOptimizationsGetTopWeight = (query: string): ScenarioOptimizationsAction => ({
    type: ScenarioOptimizationsActionTypes.GET_TOP_WEIGHT_REQUEST,
    payload: { query },
});

export const scenarioOptimizationsGetBaseChargeAmount = (query: string): ScenarioOptimizationsAction => ({
    type: ScenarioOptimizationsActionTypes.GET_BASE_CHARGE_AMOUNT_REQUEST,
    payload: { query },
});

export const scenarioOptimizationsGetAvgBaseChargeAmount = (query: string): ScenarioOptimizationsAction => ({
    type: ScenarioOptimizationsActionTypes.GET_AVG_BASE_CHARGE_AMOUNT_REQUEST,
    payload: { query },
});

export const scenarioOptimizationsGetComparisonRecords = (query): ScenarioOptimizationsAction => ({
    type: ScenarioOptimizationsActionTypes.GET_COMPARISON_ANALYTICS_RECORDS,
    payload: { query },
});

export const scenarioOptimizationsGetComparisonReport = (query): ScenarioOptimizationsAction => ({
    type: ScenarioOptimizationsActionTypes.GET_COMPARISON_ANALYTICS_REPORT,
    payload: { query },
});

export const scenarioOptimizationsGetComparisonBaseChargeAmount = (query): ScenarioOptimizationsAction => ({
    type: ScenarioOptimizationsActionTypes.GET_COMPARISON_RATES_BASE_CHARGE_AMOUNT,
    payload: { query },
});

export const scenarioOptimizationsGetComparisonAvgBaseChargeAmount = (query): ScenarioOptimizationsAction => ({
    type: ScenarioOptimizationsActionTypes.GET_COMPARISON_RATES_AVG_BASE_CHARGE_AMOUNT,
    payload: { query },
});

export const scenarioOptimizationsGetCountByWeightAndZone = (query): ScenarioOptimizationsAction => ({
    type: ScenarioOptimizationsActionTypes.GET_COUNT_BY_WEIGHT_AND_ZONE,
    payload: { query },
});